<template>
  <!-- <v-container> -->
  <v-text-field
    label="Соответствие целевым показателям (баллы)"
    v-model="targetScore"
    outlined
    readonly
    filled
  />
  <!-- </v-container> -->
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";

export default {
  name: "TheTargetScore",
  components: {},
  data: () => ({}),
  props: {},
  computed: {
    ...mapGetters({ card: GETTERS.CARD_DATA }),

    targetScore() {
      let value = 0;
      const data = this.card.target || [];
      if (
        data.includes("1") ||
        data.includes("2") ||
        data.includes("3") ||
        data.includes("4")
      )
        value = value + 10;
      if (data.includes("5") || data.includes("6") || data.includes("7"))
        value = value + 5;
      if (data.includes("8")) value = value + 5;

      if (this.card.targetScore !== value) {
        this.modify({ targetScore: value });
      }
      return value;
    },
  },
  methods: {
    ...mapMutations({
      modify: MUTATIONS.MODIFY_CARD_DATA,
    }),
  },
};
</script>
